/* ============================================================================
   CircleDrops — brand-size-heading condition tooltip (externalized)
   ----------------------------------------------------------------------------
   Save this file as:  assets/brand-size-heading.js
   Loaded from snippets/brand-size-heading.liquid with:
     <script src="{{ 'brand-size-heading.js' | asset_url }}" defer></script>

   The inline <script> this replaces had NO Liquid in it, so nothing needs to be
   bridged. It initialises every .cd-tooltip-icon on the page, so a single run
   covers the snippet wherever it appears. A global guard
   (window.__cdBrandSizeTooltipInstalled) prevents double-binding if the snippet
   is rendered more than once on a page (each render adds its own deferred tag).

   NOTE: the size-guide popup has its own script in snippets/size-guide-modal.liquid.
   Shopify does NOT render Liquid inside asset .js files; this file is pure JS.
   ========================================================================== */

(function () {
  'use strict';

  if (window.__cdBrandSizeTooltipInstalled) return;
  window.__cdBrandSizeTooltipInstalled = true;

  var PADDING = 12;

  /* ── Condition tooltip ──
     (The size-guide popup has its own script in
      snippets/size-guide-modal.liquid) */
  function positionTooltip(icon, box) {
    var vw           = window.innerWidth;
    var tooltipWidth = box.offsetWidth > 0 ? box.offsetWidth : 270;
    var iconRect     = icon.getBoundingClientRect();
    var parentRect   = box.parentElement.getBoundingClientRect();

    var iconCentre  = iconRect.left + iconRect.width / 2;
    var idealLeft   = iconCentre - tooltipWidth / 2;
    var clampedLeft = Math.max(PADDING, Math.min(idealLeft, vw - tooltipWidth - PADDING));

    box.style.left = (clampedLeft - parentRect.left) + 'px';

    var arrowLeft = iconCentre - clampedLeft;
    box.style.setProperty('--arrow-left', arrowLeft + 'px');
  }

  function initTooltips() {
    document.querySelectorAll('.cd-tooltip-icon').forEach(function (icon) {
      var box = icon.nextElementSibling;
      if (!box || !box.classList.contains('cd-tooltip-box')) return;

      var hideTimer = null;

      function show() {
        clearTimeout(hideTimer);
        box.style.transition = 'none';
        box.style.transform = 'translateY(-4px)';
        positionTooltip(icon, box);
        void box.offsetHeight;
        box.style.transition = '';
        box.classList.add('cd-active');
      }

      function scheduleHide() {
        hideTimer = setTimeout(function () {
          box.classList.remove('cd-active');
        }, 100);
      }

      icon.addEventListener('mouseenter', show);
      icon.addEventListener('mouseleave', scheduleHide);
      box.addEventListener('mouseenter', function () { clearTimeout(hideTimer); });
      box.addEventListener('mouseleave', scheduleHide);

      icon.addEventListener('touchstart', function (e) {
        e.preventDefault();
        var alreadyOpen = box.classList.contains('cd-active');

        document.querySelectorAll('.cd-tooltip-box.cd-active').forEach(function (b) {
          b.classList.remove('cd-active');
        });

        if (!alreadyOpen) {
          box.style.transition = 'none';
          box.style.transform  = 'translateY(-4px)';
          positionTooltip(icon, box);
          void box.offsetHeight;
          box.style.transition = '';
          box.classList.add('cd-active');
        }
      }, { passive: false });
    });

    document.addEventListener('touchstart', function (e) {
      if (!e.target.closest || !e.target.closest('.cd-condition-cell')) {
        document.querySelectorAll('.cd-tooltip-box.cd-active').forEach(function (b) {
          b.classList.remove('cd-active');
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTooltips);
  } else {
    initTooltips();
  }
})();